import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { atLeast } from "@/lib/roles";

export default function ProtectedRoute({ children, minRole, managerOnly = false }) {
  const { status, user } = useAuth();
  const loc = useLocation();
  if (status === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <Loader2 className="h-5 w-5 animate-spin text-blue-500" />
      </div>
    );
  }
  if (status === false) {
    return <Navigate to="/login" replace state={{ from: loc.pathname + (loc.search || "") }} />;
  }
  // Back-compat: managerOnly kept but now enforces manager+ (matches new hierarchy).
  const required = minRole || (managerOnly ? "manager" : null);
  if (required && !atLeast(user?.role, required)) {
    // Users (role: user) have no reporting access — send them to the data-entry landing.
    return <Navigate to="/sales" replace />;
  }
  return children;
}
